import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import ScrollToTop from '../ScrollToTop/ScrollToTop';

const bem = new BEMHelper('ScrollToTopWrapper');

const ScrollToTopWrapper = (props) => {
    const { className, scrollBehaviour, stickyFilters } = props;
    const modifiers = stickyFilters ? null : 'notSticky';
    return (
        <div className={bem(null, modifiers, className)}>
            {stickyFilters && <div className={bem('content')}>{props.children}</div>}
            <div className={bem('contentoffset', modifiers)}>
                <div className={bem('button', modifiers)}>
                    <ScrollToTop scrollBehaviour={scrollBehaviour} className={className} />
                </div>
            </div>
            {!stickyFilters && <div className={bem('content', modifiers)}>{props.children}</div>}
        </div>
    );
};

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    scrollBehaviour: PropTypes.string,
    stickyFilters: PropTypes.bool,
};

ScrollToTopWrapper.propTypes = propTypes;

export default ScrollToTopWrapper;
